import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--navy)', color: 'rgba(255,255,255,0.65)', padding: '4rem 2.5rem 2rem' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '3rem', marginBottom: '3rem' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.75rem' }}>
              <img src="/logo-bottom.png" alt="SolarSavings" style={{ width: 34, height: 34, objectFit: 'contain' }} />
              <span style={{ fontFamily: 'Sora, sans-serif', fontWeight: 700, color: '#fff', fontSize: '1.05rem' }}>SolarSavings</span>
            </div>
            <p style={{ fontSize: '0.875rem', lineHeight: 1.6, color: 'rgba(255,255,255,0.55)' }}>Smart Solar Finance —<br />Free for Every Customer</p>
          </div>
          <div>
            <h4 style={{ fontFamily: 'Sora, sans-serif', color: '#fff', fontSize: '0.8rem', fontWeight: 700, marginBottom: '1rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Navigation</h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {[['Home', '/'], ['Commercial', '/commercial'], ['Residential', '/residential']].map(([label, to]) => (
                <li key={to}><Link to={to} style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none', fontSize: '0.875rem' }}>{label}</Link></li>
              ))}
              <li><a href="/#insights" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none', fontSize: '0.875rem' }}>Solar Insights</a></li>
              <li><Link to="/contact" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none', fontSize: '0.875rem' }}>Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 style={{ fontFamily: 'Sora, sans-serif', color: '#fff', fontSize: '0.8rem', fontWeight: 700, marginBottom: '1rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Legal</h4>
            <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.55)', marginBottom: '0.4rem' }}>🔒 SSL Secured</p>
            <p style={{ marginBottom: '0.4rem' }}><a href="#" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none', fontSize: '0.875rem' }}>Privacy Policy</a></p>
            <p><a href="#" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none', fontSize: '0.875rem' }}>Terms of Service</a></p>
          </div>
        </div>
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1.5rem', fontSize: '0.75rem', color: 'rgba(255,255,255,0.35)', textAlign: 'center', lineHeight: 1.8 }}>
          © 2025 SolarSavings. All rights reserved.<br />
          SolarSavings is not a licensed contractor or financial advisor. All estimates are for informational purposes only.
        </div>
      </div>
    </footer>
  );
}
